import {useCallback} from 'react';

import {assertPolicyFilter} from 'filters/types';

import {PageFilter} from 'filters';
import {useCountPoliciesLazyQuery} from 'features/GlobalFilterProvider/api/countPolicies.generated';
import {clearFilter} from 'filters/utils';
import {useDebouncedPromise} from 'utils/hooks/useDebouncedPromise';

export const useGlobalFilterWarn = () => {
  const [countPolicies] = useCountPoliciesLazyQuery();

  const debouncedCheck = useDebouncedPromise(async (filter: PageFilter) => {
    assertPolicyFilter(filter);
    const {data} = await countPolicies({
      variables: {
        filter: clearFilter(filter),
      },
    });

    return data?.aggregatePolicy.metric ? true : 'No results, please expand your filter criteria';
  }, 1000);

  return useCallback((filter: PageFilter) => debouncedCheck(filter), [debouncedCheck]);
};
